import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { ReportMetadata } from '../../models/report.model';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ReportdashboardService } from '../reportdashboard.service';

@Injectable()
export class ReportMetadataResolver implements Resolve<ReportMetadata> {

    private subscription: any;

    constructor(private reportService: ReportdashboardService, private activatedRoute: ActivatedRoute) {

    }
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ReportMetadata>  {
        const reportScheduleId = route.paramMap.get('id');
        //console.log(reportScheduleId);
        return this.reportService.getReportScheduleById(reportScheduleId);
    }
}
